'use strict';

var variables = require('./variables-1eb6495a.js');

const light = {
    root: {
        flex: "0 0 48px",
        flexDirection: "row",
        boxShadow: `inset 0 -1px 0 0 ${variables.COLORS.GREYSCALE_0_15}`,
    },
    colorPrimary: {
        backgroundColor: variables.COLORS.WHITE,
        color: variables.COLORS.TEXT_PRIMARY,
    },
};

var MuiAppBar = /*#__PURE__*/Object.freeze({
  __proto__: null,
  light: light
});

exports.MuiAppBar = MuiAppBar;
exports.light = light;
